import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import { setItem } from "../../../utils/storageHelper";

// Action Types
// REFACTORED: Action type is now namespaced to be unique.
export const SET_USER_SETTINGS = "settings/SET_USER_SETTINGS";
export const SAVE_SETTINGS_ERROR = "settings/SAVE_SETTINGS_ERROR";

// Thunk Action Creator
export const saveSettings = createAsyncThunk(
    "api/User/saveSettings",
    async (json, { dispatch }) => {

        try {
            const response = await axios.put(
                `${import.meta.env.VITE_PUBLIC_DOMAIN}User/saveSettings`,
                {
                    ZoomLevel: json.zoomLevel,
                    DefaultView: json.defaultView,
                    AiAssistant: json.aiAssistant,
                    Theme: json.theme,
                    ShowDueDate: json.showDueDate,
                    ShowVisualSize: json.showVisualSize,
                    ShowTaskProgress: json.showTaskProgress
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            if (response.status == 200) {
                if (response.data === '') {
                    throw new Error("The last task has not been saved. Logging the user out");
                } else {
                    await setItem(
                        `usersettings:${import.meta.env.VITE_PUBLIC_APP_ENV}`,
                        JSON.stringify(response.data)
                    );

                    dispatch({
                        // REFACTORED: Dispatching with the new, unique action type.
                        type: SET_USER_SETTINGS,
                        payload: response.data,
                    });
                }
            }
            else {
                throw new Error("Error saving user settings");
            }
        }
        catch (error) {
            dispatch({ type: SAVE_SETTINGS_ERROR, payload: error });
        }
    }
);